import React from "react";

export const feedFilterTypes = [
  {
    label: "All",
    key: "all",
  },
  {
    label: "Company",
    key: "company",
  },
  {
    label: "My Location",
    key: "location",
  },
  {
    label: "Recognition",
    key: "recognition",
  },
  {
    label: "Polls",
    key: "polls",
  },
  {
    label: "For you",
    key: "for_you",
  },
];

export const feedLimitedFilterTypes = [
  {
    label: "My Location",
    key: "location",
  },
  {
    label: "Recognition",
    key: "recognition",
  },
  {
    label: "Polls",
    key: "polls",
  },
  {
    label: "For you",
    key: "for_you",
  },
];

export const feedTypes = [
  "company update",
  "priority",
  "news",
  "announcement",
  "kudos",
  "poll",
  "event",
  // 'question',
  // 'incident reporting',
  // 'meeting',
  // 'task checklist',
  // 'polls/pulse survey',
];

export const managerFeedTypes = [
  "priority",
  "news",
  "announcement",
  "kudos",
  "poll",
  "event",
];

export const employeeFeedTypes = [
  "news",
  "announcement",
  "kudos",
  "poll",
  "event",
];

export const feedKudosTypes = [
  {
    label: "Employee of the month",
    key: "employee_of_the_month",
    points: 2,
  },
  {
    label: "Congratulations",
    key: "congratulations",
    points: 1,
  },
  {
    label: "You're a star",
    key: "star",
    points: 1,
  },
  {
    label: "Thank you",
    key: "thank_you",
    points: 1,
  },
  {
    label: "Work Anniversary",
    key: "work_anniversary",
    points: 1,
  },
  // {
  //   label: "Happy Birthday",
  //   key: "happy_birthday",
  //   points: 1,
  // },
];

/** Predefined recognition values (submitted as kudos_value[0] … kudos_value[3]). */
export const feedKudosValues = [
  {
    label: "Compassion",
    key: "compassion",
    description: "Show empathy and care for others in every interaction.",
  },
  {
    label: "Teamwork",
    key: "teamwork",
    description:
      "Work together and support colleagues to achieve shared goals.",
  },
  {
    label: "Excellence",
    key: "excellence",
    description: "Strive for the highest standards in everything you do.",
  },
  {
    label: "Integrity",
    key: "integrity",
    description: "Act with honesty, transparency, and strong moral principles.",
  },
  {
    label: "Respect",
    key: "respect",
    description: "Treat everyone with dignity and value diverse perspectives.",
  },
  {
    label: "Innovation",
    key: "innovation",
    description: "Embrace new ideas and creative ways to improve.",
  },
  {
    label: "Inspire Together",
    key: "inspire_together",
    description:
      "Support and uplift one another to build a strong, united team.",
  },
  {
    label: "Make a Difference",
    key: "make_a_difference",
    description:
      "Create meaningful, positive impact through dedicated daily effort.",
  },
  {
    label: "Positively Appreciate",
    key: "positively_appreciate",
    description: "Show gratitude and recognise that every effort matters.",
  },
  {
    label: "Apply Trust",
    key: "apply_trust",
    description:
      "Be dependable and honest while treating everyone with dignity.",
  },
  {
    label: "Care Graciously",
    key: "care_graciously",
    description: "Lead with kindness, respect, and compassion for all.",
  },
  {
    label: "Transparent Leadership",
    key: "transparent_leadership",
    description: "Lead by example and follow through on what you say.",
  },
];

export const MAX_KUDOS_VALUES = 4;

export const KUDOS_VALUE_FORM_KEYS = [
  "kudos_value_0",
  "kudos_value_1",
  "kudos_value_2",
  "kudos_value_3",
];

export const emptyKudosValueFormState = () =>
  Object.fromEntries(KUDOS_VALUE_FORM_KEYS.map((key) => [key, ""]));

export const readKudosValueSlots = (formValues) =>
  KUDOS_VALUE_FORM_KEYS.map((key) => String(formValues?.[key] ?? "").trim());

export const kudosValuesToFormState = (values) => {
  const trimmed = (Array.isArray(values) ? values : [])
    .map((value) => String(value ?? "").trim())
    .filter(Boolean)
    .slice(0, MAX_KUDOS_VALUES);

  return Object.fromEntries(
    KUDOS_VALUE_FORM_KEYS.map((key, index) => [key, trimmed[index] ?? ""]),
  );
};

export const appendKudosValuesToFormData = (formdata, formValues) => {
  KUDOS_VALUE_FORM_KEYS.forEach((key, index) => {
    formdata.append(
      `kudos_value[${index}]`,
      String(formValues?.[key] ?? "").trim(),
    );
  });
};

export const getKudosValuesFromFeed = (data) => {
  const v = data?.values ?? data?.kudos_value;
  if (Array.isArray(v)) {
    return v
      .map((x) => (x == null ? "" : String(x).trim()))
      .filter(Boolean)
      .slice(0, MAX_KUDOS_VALUES);
  }
  if (v && typeof v === "object") {
    const nums = Object.keys(v)
      .filter((k) => /^\d+$/.test(String(k)))
      .sort((a, b) => Number(a) - Number(b));
    const ordered = nums.length ? nums.map((k) => v[k]) : Object.values(v);
    return ordered
      .map((x) => (x == null ? "" : String(x).trim()))
      .filter(Boolean)
      .slice(0, MAX_KUDOS_VALUES);
  }
  const slots = [
    data?.value_0,
    data?.value_1,
    data?.value_2,
    data?.value_3,
    data?.values_0,
    data?.values_1,
    data?.values_2,
    data?.values_3,
    ...KUDOS_VALUE_FORM_KEYS.map((key) => data?.[key]),
  ]
    .map((x) => (x == null ? "" : String(x).trim()))
    .filter(Boolean);
  return slots.slice(0, MAX_KUDOS_VALUES);
};

export const resetTypeSpecificFields = ({ previousType, nextType }) => {
  const patch = {};

  if (previousType === nextType) {
    return patch;
  }

  if (previousType === "kudos" && nextType !== "kudos") {
    patch.kudos_type = "";
    Object.assign(patch, emptyKudosValueFormState());
  }

  if (previousType === "event" && nextType !== "event") {
    patch.event_date = "";
    patch.event_start_time = "";
    patch.event_end_time = "";
    patch.event_location = "";
  }

  if (previousType === "poll" && nextType !== "poll") {
    patch.poll_type = "text";
    patch.question = "";
    patch.options = [];
    patch.allow_multiple = false;
    patch.show_results_after_vote = false;
    patch.expires_at = "";
  }

  if (nextType === "kudos" && !patch.kudos_type) {
    patch.kudos_type = "congratulations";
  }

  patch.is_acknowledgement_required = nextType === "priority";

  return patch;
};

export const feedToAdminTypes = ["company", "location", "employee", "team"];

export const feedToTypes = ["location", "employee", "team"];

export const feedStringKeys = [
  "target",
  "title",
  "description",
  "feed_type",
  "kudos_type",
  "is_acknowledgement_required",
  "is_comment_disabled",
  "is_reaction_disabled",
  "event_date",
  "event_start_time",
  "event_end_time",
  "event_location",
];

export const reactionTypes = ["like"];

export const reactionIcons = {
  like: "👍",
};

export const feedPollTypes = ["text", "image"];

export const formatFeedVotes = (votes) => {
  // Handle empty array, null, or undefined
  if (!votes || !Array.isArray(votes) || votes.length === 0) {
    return [];
  }

  const formattedVotes = votes.map((vote) => {
    const votedEmployees = vote.voted_employees || [];

    return {
      ...vote,
      display_list: votedEmployees.slice(0, 5),
      all_list: votedEmployees,
    };
  });

  return formattedVotes;
};
